import React from 'react'
import Create from '../crud/create'
import fields from './fields'
import menuItems from './menuItems'

const CreateProductDiscount = (props) => {
  return (
    <Create
      title='Add Discount to Category'
      fields={fields}
      apiPath='admin/category_discounts'
      successRedirectPath={() => '/ecommerce/category-discounts'}
      buildMenuItems={menuItems}
    />
  )
}

export default CreateProductDiscount
